import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const ns = ['customTranslation', 'common'];
const supportedLngs = ['en', 'de'];

const resources = ns.reduce((acc, n) => {
  supportedLngs.forEach((lng) => {
    if (!acc[lng]) acc[lng] = {};

    if (n === 'common') {
      acc[lng] = {
        ...acc[lng],
        // eslint-disable-next-line
        [n]: require(`../node_modules/@klangio/react-shared-elements/public/locales/${lng}/${n}.json`),
      };
    } else {
      acc[lng] = {
        ...acc[lng],
        // eslint-disable-next-line
        [n]: require(`../src/assets/locales/${lng}/${n}.json`),
      };
    }
  });
  return acc;
}, {});

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // debug: true,
    lng: window.location.href.indexOf('/de/') > -1 ? 'de' : 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'customTranslation',
    fallbackNS: ['common'],
    ns,
    supportedLngs,
    resources,
  });

export default i18n;
